import React from 'react';
import { EMZI_COLORS, EMZI_RADIUS, EMZI_SPACING } from '../../styles/emziCI';

/**
 * ChipTag Component - EMZI CI Flat v6.3
 * ======================================
 * Reusable chip/tag component for tags, badges, and labels
 * 
 * Features:
 * - Flat design with CI blue border
 * - Delete (×) interaction
 * - Hover effects
 * - Multiple color variants
 */

const ChipTag = ({
  label,
  onDelete,
  variant = 'default', // 'default' | 'status' | 'type'
  color,
  icon,
  size = 'md', // 'sm' | 'md'
  className = '',
}) => {
  const getVariantStyles = () => {
    const baseStyles = {
      display: 'inline-flex',
      alignItems: 'center',
      gap: EMZI_SPACING.xs,
      borderRadius: EMZI_RADIUS.sm,
      border: `1px solid ${color || EMZI_COLORS.primary}`,
      backgroundColor: EMZI_COLORS.background,
      color: color || EMZI_COLORS.primary,
      fontWeight: '500',
      transition: 'all 0.2s ease',
      cursor: onDelete ? 'default' : 'auto',
    };

    const sizeStyles = {
      sm: {
        padding: '4px 8px',
        fontSize: '11px',
        lineHeight: '1.3',
      },
      md: {
        padding: '6px 12px',
        fontSize: '12px',
        lineHeight: '1.4',
      },
    };

    return { ...baseStyles, ...sizeStyles[size] };
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    if (onDelete) onDelete();
  };

  return (
    <span
      style={getVariantStyles()}
      className={className}
    >
      {icon && <span style={{ fontSize: size === 'sm' ? '14px' : '16px' }}>{icon}</span>}
      <span>{label}</span>
      {onDelete && (
        <button
          onClick={handleDelete}
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            marginLeft: EMZI_SPACING.xs,
            cursor: 'pointer',
            color: 'inherit',
            fontSize: size === 'sm' ? '14px' : '16px',
            lineHeight: 1,
            fontWeight: 'bold',
            opacity: 0.6,
            transition: 'opacity 0.2s',
          }}
          onMouseEnter={(e) => (e.target.style.opacity = 1)}
          onMouseLeave={(e) => (e.target.style.opacity = 0.6)}
          aria-label="Remove tag"
        >
          ×
        </button>
      )}
    </span>
  );
};

export default ChipTag;
